import { render, staticRenderFns } from "./MultiSelectInput.vue?vue&type=template&id=2b9fef2b&scoped=true&"
import script from "./MultiSelectInput.vue?vue&type=script&lang=js&"
export * from "./MultiSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectInput.vue?vue&type=style&index=0&id=2b9fef2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9fef2b",
  null
  
)

export default component.exports